import { render, staticRenderFns } from "./business-consulting-details.vue?vue&type=template&id=463a839a&scoped=true&"
import script from "./business-consulting-details.vue?vue&type=script&lang=ts&"
export * from "./business-consulting-details.vue?vue&type=script&lang=ts&"
import style0 from "./business-consulting-details.vue?vue&type=style&index=0&id=463a839a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a839a",
  null
  
)

export default component.exports